import { GzHealthDashboardInsights } from './GzHealthDashboardInsights';
import { HealthDashboardProductUpdateStrings, InsightsTemplatesStringKeys } from '../types';
import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_HEALTH_DASHBOARD_PRODUCT_UPDATE } from '../../../../webcomponents.constants';
import { translateFn } from '../../../../utils/translator.helper';
import { WidgetSectionItemSeverity } from '../../../../ui/gzWidgetSectionItem/types';

@customElement(WEB_COMPONENT_HEALTH_DASHBOARD_PRODUCT_UPDATE)
export class GzHealthDashboardProductUpdateStatusWebComponent extends GzHealthDashboardInsights {
  protected widgetKey = InsightsTemplatesStringKeys.PRODUCT_UPDATE_STATUS;

  protected strings: HealthDashboardProductUpdateStrings = {
    sections: [
      {
        key: InsightsTemplatesStringKeys.PRODUCT_INFO,
        items: [
          {
            key: InsightsTemplatesStringKeys.UPDATED,
            name: translateFn('Updated'),
            tooltipText: translateFn('Endpoints are up to date, and no new updates are currently available.'),
            severity: WidgetSectionItemSeverity.SUCCESS,
          },
          {
            key: InsightsTemplatesStringKeys.PENDING_RESTART,
            name: translateFn('Pending restart'),
            tooltipText: translateFn('Endpoints require a system restart to complete the update process.'),
            severity: WidgetSectionItemSeverity.WARNING,
          },
          {
            key: InsightsTemplatesStringKeys.UPDATE_DISABLED,
            name: translateFn('Update disabled'),
            tooltipText: translateFn('Product update option is disabled from the policy applied on endpoints.'),
            severity: WidgetSectionItemSeverity.WARNING,
          },
          {
            key: InsightsTemplatesStringKeys.OUTDATED,
            name: translateFn('Outdated'),
            tooltipText: translateFn('Endpoints were online within the past 24 hours but could not receive updates.'),
            severity: WidgetSectionItemSeverity.ERROR,
          },
        ],
      },
    ],
  };
}
